import { useState } from 'react'
import { Button } from '@winnin/winnin_ui.components.button'
import { Icon } from '@winnin/winnin_ui.components.icon'
import { Illustration } from '@winnin/winnin_ui.components.illustration'
import { InputWithLabel } from '@winnin/winnin_ui.components.input-with-label'

import { T, useTranslate } from 'lib/tolgee'

import { analyticsTracker, localStorageUtils, TOLGEE_GLOBALS } from '../../../../utils'
import './index.scss'

const TOLGEE_PREFFIX = 'PrintCSATPopup'

interface ICSATPopup {
  closePopup: () => void
}

export default function CSATPopup({ closePopup }: ICSATPopup) {
  const [comment, setComment] = useState('')
  const [hasAnsweredCSat, setHasAnsweredCSat] = useState(false)
  const t = useTranslate()

  const handleChange = event => {
    const inputValue = event.target.value
    setComment(inputValue)
  }

  const handleSubmit = () => {
    const { SEND_CSAT } = analyticsTracker.eventNames
    analyticsTracker.eventTrack(SEND_CSAT, {
      CSatType: 'Print Button',
      entityType: 'Chart',
      comment,
    })
    localStorageUtils.setObject('answered-print-csat', true)
    setHasAnsweredCSat(true)
  }

  if (hasAnsweredCSat) {
    return (
      <div className="PrintButton-CSATPopup-wrapper confirmation skipOnPrint">
        <div className="titleRow">
          <button onClick={closePopup}>
            <Icon icon="close" height={8} width={8} />
          </button>
        </div>
        <Illustration name="dialog" width="60px" />
        <p className="answeredTitle">
          <T keyName={`${TOLGEE_PREFFIX}-answeredText`}>Obrigado! Sua ajuda é muito importante para nós</T>
        </p>
        <Button appearance="link" onClick={() => setHasAnsweredCSat(false)} icon="edit">
          <T keyName={`${TOLGEE_PREFFIX}-editButton`}>Editar resposta</T>
        </Button>
      </div>
    )
  }

  return (
    <div className="PrintButton-CSATPopup-wrapper skipOnPrint">
      <div className="titleRow">
        <T keyName={`${TOLGEE_PREFFIX}-title`}>O download da sua imagem foi realizado!</T>
        <button onClick={closePopup}>
          <Icon icon="close" height={8} width={8} />
        </button>
      </div>
      <div className="inputSection">
        <label>
          <T keyName={`${TOLGEE_PREFFIX}-inputLabel`} parameters={{ span: <span /> }}>
            {'Antes de ir, pode nos dizer como você pretende utilizar esses dados? <span>(Opcional)</span>'}
          </T>
        </label>
        <InputWithLabel
          onChange={handleChange}
          value={comment}
          name="reason"
          type="textarea"
          rows={4}
          placeholder={t({
            defaultValue: 'Ex: Gostaria de utilizar essa imagem com o objetivo de compor um relatório para meu time.',
            key: `${TOLGEE_PREFFIX}-inputPlaceholder`,
          })}
        />
      </div>
      <div className="buttonSection">
        <Button disabled={!comment} onClick={handleSubmit}>
          {t(TOLGEE_GLOBALS.confirm)}
        </Button>
      </div>
    </div>
  )
}
